import React from 'react';
import Styles from './BlogPost.module.less';

type TableProps = {
    value: {
        rows: {
            cells: string[];
        }[];
    };
};

export const Table = ({ value }: TableProps) => {
    return (
        <table className={Styles.postTable}>
            <thead>
                <tr>
                    {value.rows[0].cells.map((cell, i) => (
                        <th key={i}>{cell}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {value.rows.slice(1).map((row, i) => (
                    <tr key={i}>
                        {row.cells.map((cell, i) => (
                            <td key={i}>{cell}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
